((document, window) => {
  
    let requestAnimationFrame;

    // Get the top position of an element in the document
    const getTop = (element, start) => {
        // return value of html.getBoundingClientRect().top ... IE : 0, other browsers : -pageYOffset
        if (element.nodeName === 'HTML') return -start;

        const elementTop = element.getBoundingClientRect().top;
        const scrollMarginTop = parseInt((window.getComputedStyle(element).scrollMarginTop || 0).toString(), 10);
        return elementTop + start - scrollMarginTop;
    };

    /**
     * ease in out function
     * @see https://gist.github.com/gre/1650294
    **/
    easeInOutCubic = (t) => {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    };

    const smoothScrollTo = function (scrollTo) {
        const duration = 500;
        const offset = -350;

        if (!requestAnimationFrame) {
            requestAnimationFrame = window.requestAnimationFrame ||
                function (fn) {
                    window.setTimeout(fn, 16);
                };
        }

        const startPoint = window.pageYOffset;
        // Get the top position of an element in the document
        // return value of html.getBoundingClientRect().top ... IE : 0, other browsers : -pageYOffset
        let end = getTop(scrollTo, startPoint);

        // Ajusts offset from the end
        end += offset;

        const clock = Date.now();
        const easeFn = easeInOutCubic;
        const step = () => {
            // the time elapsed from the beginning of the scroll
            const elapsed = Date.now() - clock;
            // calculate the scroll position we should be in
            let position = end;
            if (elapsed < duration) {
                position = startPoint + (end - startPoint) * easeFn(elapsed / duration);

                requestAnimationFrame(step);
            }

            window.scrollTo(0, position);
        };
        step();
    };

    const waitForElementToExist = function (selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }

    const handleDocumentLoaded = function (e) {
        let starRatingClickBound = false;
        document.addEventListener('oke-rendered', ((e) => {
            if (e.detail && e.detail.widget === 'star-rating' && !starRatingClickBound) {
                const okendoStarRatingElements = document.querySelectorAll('[data-oke-star-rating]');
                const okendoReviewsWidgetElement = document.querySelector('#okeReviews-scrollTarget');
                const productTabReviews = document.querySelector('li[data-tab="reviews"]');
                if (okendoStarRatingElements && productTabReviews) {
                    waitForElementToExist('.oke-star-rating-container div[data-oke-star-rating][data-oke-rendered]').then((elm) => {
                        Array.from(okendoStarRatingElements).forEach(starRating => {
                          const clone = starRating.cloneNode(true);
                          clone.classList.add('oke-sr-clone');
                          clone.style.cursor = 'pointer';
                          clone.style.display = 'inline-block';
                          clone.addEventListener('click', function (event) {
                              event.preventDefault();

                              productTabReviews.click();
                              setTimeout(() => smoothScrollTo(okendoReviewsWidgetElement), 300);
                          });
                          starRating.replaceWith(clone);
                        });
                    });
                }

                starRatingClickBound = true;
            }
        }));
    };

    if (document.readyState !== 'interactive' && document.readyState !== 'complete') {
        document.addEventListener('readystatechange', () => {
            handleDocumentLoaded();
        }, { once: true });
    }
    else {
        handleDocumentLoaded();
    }
})(document, window);